import React from "react";
import Constants from "../../constants/constants";
function Footer(props) {
  const year = new Date();
  return (
    <footer>
     {Constants.CopyRightReserved} /{" "}
      <a rel="noreferrer" href="https://daftareshoma.com/" target="_blank">
        {Constants.CopyRightLink}
      </a>
      &nbsp; &nbsp; &#169; &nbsp;
      {year.getFullYear()}
    </footer>
  );
}
export default Footer;
